import { useContext, useEffect, useState } from 'react';
import usePlanServiceApi from 'hooks/usePlanServiceApi';
import catchCancel from 'helpers/catchCancel';
import { parseServerError } from 'helpers/errorHelpers';
import { Context } from 'components/Store';
import {
  PLAN_FETCH_V2,
  PLAN_FETCH_V2_BY_ORG,
  PLAN_CREATE_V2,
  PLAN_CREATE_V2_BY_ORG,
  PLAN_UPDATE_V2,
  PLAN_UPDATE_V2_BY_ORG
} from 'constants/planServiceV2Flags';

const usePlanData = id => {
  const fetchApi = usePlanServiceApi(
    'plan',
    PLAN_FETCH_V2,
    PLAN_FETCH_V2_BY_ORG
  );
  const createApi = usePlanServiceApi(
    'plan',
    PLAN_CREATE_V2,
    PLAN_CREATE_V2_BY_ORG
  );
  const updateApi = usePlanServiceApi(
    'plan',
    PLAN_UPDATE_V2,
    PLAN_UPDATE_V2_BY_ORG
  );
  const [, dispatch] = useContext(Context);

  const [plan, setPlan] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const isCreateScreen = id === 'plan';
    let cancel;
    if (!isCreateScreen) {
      const { promise, cancel: _cancel } = fetchApi.fetch(id);
      cancel = _cancel;
      promise
        .then(({ data }) => {
          // setPlan(transformPlanForGet(data.data));
          setPlan(data);
        })
        .catch(catchCancel)
        .catch(parseServerError(dispatch))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
    return () => cancel && cancel();
  }, [dispatch, id, fetchApi]);

  const savePlan = (values, duplicating) => {
    if (id === 'plan' || duplicating === 'edit-dup') {
      const saveValues = { ...values };
      delete saveValues.organizationId;
      saveValues.cropZones = saveValues.cropZones?.map(
        // eslint-disable-next-line no-unused-vars
        ({ id: _, ...cropZone }) => cropZone
      );
      saveValues.planProductEntries = saveValues?.planProductEntries?.map(
        product => ({
          ...product,
          trackingId: '',
          productRateValue: product.productRateValue.toString()
        })
      );

      setSaving(true);
      const { promise } = createApi.create(saveValues);
      return promise
        .catch(catchCancel)
        .catch(parseServerError(dispatch))
        .finally(() => {
          setSaving(false);
        });
    }
    setSaving(true);
    const { promise } = updateApi.update(id, values);
    return promise
      .catch(catchCancel)
      .catch(parseServerError(dispatch))
      .finally(() => {
        setSaving(false);
      });
  };

  return {
    plan,
    loading,
    saving,
    savePlan,
    setPlan
  };
};

export default usePlanData;
